import { render, staticRenderFns } from "./IconSetting.vue?vue&type=template&id=c12dda84&scoped=true"
import script from "./IconSetting.vue?vue&type=script&lang=js"
export * from "./IconSetting.vue?vue&type=script&lang=js"
import style0 from "./IconSetting.vue?vue&type=style&index=0&id=c12dda84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12dda84",
  null
  
)

export default component.exports